import {
  MAIL_LOADING,
  MAIL_LOADING_END,
  MAIL_SENT,
  MAIL_SENT_FAIL,
  MAIL_SENT_RESET,
} from "../actions/types";

const initialState = {
  loading: false,
  mailsent: null,
};

export default function mailReducer(state = initialState, action) {
  let { type, payload } = action;
  switch (type) {
    case MAIL_LOADING:
      return {
        ...state,
        loading: true,
      };
    case MAIL_LOADING_END:
      return {
        ...state,
        loading: false,
      };
    case MAIL_SENT:
      return {
        ...state,
        mailsent: true,
      };
    case MAIL_SENT_FAIL:
      return {
        ...state,
        mailsent: false,
      };
    case MAIL_SENT_RESET:
      return {
        ...state,
        mailsent: null,
      };

    default:
      return {
        ...state,
      };
  }
}
